module.exports = __webpack_public_path__ + "img/searchFail.9f12a6be.jpg";